import React from "react";
import { Switch } from "react-router-dom";
import Route from "./Route";

import Footer from '../../components/Footer';

import HomePage from '../../containers/HomePage';
import ResetPassword from '../../containers/ResetPassword';
import LoginPage from '../../containers/LoginPage/';
import ForgotPassword from '../../containers/ForgotPassword';
import ChangePassword from '../../containers/ChangePassword';
import EmployeePage from '../../containers/EmployeePage';
import Position from '../../containers/Position';
import UploadFile from '../../containers/Upload';
import ErrorPage from '../../containers/ErrorPage';
import Department from '../../containers/Department';
import ProjectType from '../../containers/ProjectType';
import OmProject from '../../containers/OmProject';
import Project from '../../containers/Project';
import InquiryData from '../../containers/InquiryData'
import WorkingHour from '../../containers/WorkingHour';
import Approve from "../../containers/Approve";
import TotalRecord from "../../containers/TotalRecord";
import ShiftControl from "../../containers/ShiftControl";
import TotalRecordDetail from "../../containers/TotalRecordDeTail";
import MyLeaveRequest from "../../containers/MyLeaveRequest";
import AllLeaveRequest from "../../containers/AllLeaveRequest";
import LeaveManagementConfig from "../../containers/LeaveManagementConfig";
import ManagementPage from "../../containers/NewLeaveRequest";
import Holiday from "../../containers/Holiday";
import LeaveHistory from "../../containers/LeaveHistory";
import LeaveOverview from "../../containers/LeaveOverview";
import AllDetailRequestPage from "../../containers/AllDetailRequestPage";
import MyDetailRequestPage from "../../containers/MyDetailRequestPage";

export default function Routes() {
    return (
        <div>
            <Switch>
                {/* 
                    isPrivate if not login
                    isHeader if not header
                    isStaff if want staff connect route 
                */}
                
                {/* Not login */}
                <Route isPrivate isHeader path="/" exact data={<LoginPage />} />
                <Route isPrivate isHeader path="/login" exact data={<LoginPage />} />
                <Route isPrivate isHeader path="/forgot-password" exact data={<ForgotPassword />} />
                {/* <Route isPrivate isHeader path="/reset-password/:code" exact data={(props) => <ResetPassword {...props} />} /> */}
                <Route isPrivate isHeader path="/reset-password/:code" exact data={<ResetPassword />} />
                
                {/* isLogin == true */}

                <Route path="/position" exact data={<Position />} />
                <Route path="/upload-file" exact data={<UploadFile />} />
                <Route path="/employee" exact data={<EmployeePage />} />
                <Route path="/department" exact data={<Department />} />
                <Route path="/project-type" exact data={<ProjectType />} />
                <Route path="/om-project-management" exact data={<OmProject />} />
                <Route path="/project" exact data={<Project />} />
                <Route isLeave path="/my-leave-request" exact data={<MyLeaveRequest />} />
                <Route isLeave path="/my-leave-request/new-leave-request" exact data={<ManagementPage />} />
                <Route isLeave isStaff path="/all-leave-request" exact data={<AllLeaveRequest />} />
                <Route isLeave isStaff path="/all-leave-request/leave-history" exact data={<LeaveHistory />} />
                <Route isLeave isStaff path="/all-leave-request/leave-history/detail" exact data={<AllDetailRequestPage />} />
                <Route isLeave path="/my-leave-request/detail" exact data={<MyDetailRequestPage />} />
                <Route isLeave isHr path="/config" exact data={<LeaveManagementConfig />} />
                <Route isLeave path="/holiday" exact data={<Holiday />} />
                <Route isLeave isStaff path="/leave-overview" exact data={<LeaveOverview />} />
                <Route isStaffManager path="/approve" exact data={<Approve />} />
                <Route isStaffManager path="/shift-control" exact data={<ShiftControl />} />
                <Route isDirector isStaffManager path="/total-record-detail" exact data={<TotalRecordDetail />} />
                <Route isStaff path="/inquiry-data" exact data={<InquiryData />} />
                <Route isStaff path="/update-working-hour" exact data={<WorkingHour />} />
                <Route isDirector isStaffManager isStaffSupervisor path="/total-record" exact data={<TotalRecord />} />

                <Route isStaff path="/engineer-hour-record" exact data={<HomePage />} />
                <Route isStaff isHeader path="/change-password" exact data={<ChangePassword />} />

                {/* error page */}
                <Route isStaff isError path="/error/404" exact data={<ErrorPage errorCode='404' />} />
                <Route isStaff isError path="/error/500" exact data={<ErrorPage errorCode='500' />} />
                <Route isStaff exact data={<ErrorPage errorCode='404' />} />

            </Switch>
            <Footer />
        </div>
    );
}
